import React, { useState, useEffect, useRef } from 'react';
import { useForm, useFieldArray, get, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import NiceModal, { useModal, bootstrapDialog } from '@ebay/nice-modal-react';
import BootstrapModal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { instance } from '../axios';
import { useNavigate, useParams } from 'react-router-dom';
import { UiClientSelect, UiInput, UiButton, UiSelect, UiDatePicker, BgLoader, OverlayLoader, PageError, titleCase } from '../ui';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from '../state.js';
import { MdOutlineDragHandle } from 'react-icons/md';
import { setStorage, getStorage, rupees } from '../helper.js';
import { Dropdown, Popconfirm, Menu } from 'antd';
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';

const SortableContainer = sortableContainer(({ children }) => {
  return <div className="">{children}</div>;
});

const DragHandle = sortableHandle(() => (
  <span className="h2 pe-2 mb-0 text-secondary">
    <MdOutlineDragHandle />
  </span>
));

const SortableItem = sortableElement((value) => {
  return (
    <div className="d-flex pitable bg-white" style={{ minWidth: '650px' }} {...value} />
  );
});

const JournalVoucher = NiceModal.create(({ id, type, action, bgColor, note = "", data }) => {
  const [input, setInput] = useState(note);
  const [state, setState] = useState({ count: 0 });
  const [loader, showLoader] = useState(false);
  const modal = useModal();
  const zstate = useStore((state) => state.categories);
  const mstate = useStore((state) => state.machines);
  const setZState = useStore((state) => state.setGroups);
  const inputRef = useRef(null);

  const schema = yup.object().shape({
    date: yup.string().nullable().required('Date is required'),
    series: yup.string().nullable().required('Series is required'),
    num: yup.string().nullable().required('Voucher number is required'),
    staff: yup.mixed().nullable().required('Staff is required'),



    entry: yup.array().of(
      yup.object().shape({
        account: yup.mixed().nullable().required('Account is required'),
        type: yup.string().nullable().required('Type is required'),

        narration: yup.string().nullable(),




        credit: yup.number()
          .when('type', {
            is: 'Cr',
            then: yup.number()
              .typeError('Enter a valid amount')
              .min(0, 'Negative value not allowed')
              .required('Credit amount is required'),
            otherwise: yup.number().nullable(),
          }),
        debit: yup.number()
          .when('type', {
            is: 'Dr',
            then: yup.number()
              .typeError('Enter a valid amount')
              .min(0, 'Negative value not allowed')
              .required('Debit amount is required'),
            otherwise: yup.number().nullable(),
          }),




      }, []),
    ),



  }, []);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    unregister,
    getValues,
    resetField,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const fetchData = () => {
    instance
      .get("/get_voucher?type=" + type + "&id=" + id)
      .then(function (response) {
        setState(response.data)
        if (id == 'new') {
          reset({ ...response.data.voucher, date: getStorage('last_date'), staff: JSON.parse(getStorage('staff')) })
        } else {
          reset(response.data.voucher)
        }

      })
      .catch(function (error) { })
      .then(function () { });
  }

  const fetchBalance = (id, date, i) => {
    instance
      .get("/fetch_balance?type=account&id=" + id + "&date=" + date)
      .then(function (response) {
        console.log(response.data)
        setValue(`entry.${i}.balance`, response.data.balance);

      })
      .catch(function (error) { })
      .then(function () { });
  }


  const onSubmitHandler = async (data) => {
    SaveVoucher(data);
  };

  const { fields, append, move, remove } = useFieldArray({
    control,
    name: 'entry',
  });

  const insertEntry = () => {
    append({ account: null, credit: null, debit: null, narration: null });
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    move(oldIndex, newIndex)
  };

  const SaveVoucher = (e) => {
    if (state.credit != state.debit) {
      toast('Credit and Debit must be same', { type: 'error' });
      return false
    } else {
      showLoader(true);
    }

    instance({
      method: 'post',
      url: '/update_voucher',
      data: e,
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        showLoader(false);
        if (response.data.status === 'error') {
          toast(response.data.msg, { type: 'error' });
        }
        if (response.data.status === 'success') {
          toast(response.data.msg, { type: 'success' });
          modal.resolve({ resolved: true });
          if (id == 'new') {
            reset();
            fetchData();
            if (inputRef.current) {
              inputRef.current.input.focus();
            }
          } else {

            modal.hide();
          }

        }
      })
      .catch(function (response) { });
  };


  const handleDelete = (id) => {
    var tid = id.toString();

    showLoader(true)
    instance
      .get("/delete_voucher?type="+type+"&id=" + tid)
      .then(function (response) {
        showLoader(false)
        if (response.data.status == 'success') {
          modal.resolve({ resolved: true });
          modal.hide();
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }


      })



  }


  useEffect(() => {
    fetchData();
  }, []);

  const entryWatch = watch('entry', fields);

  const calcTotal = () => {
    const totalCredit = getValues('entry').reduce((sum, field) => {
      return sum + (parseFloat(field.credit) || 0);
    }, 0);

    const totalDebit = getValues('entry').reduce((sum, field) => {
      return sum + (parseFloat(field.debit) || 0);
    }, 0);
    setState((prev) => ({ ...prev, credit: totalCredit, debit: totalDebit }));
  }
  useEffect(() => {
    calcTotal();
  }, [entryWatch]);


  const numSeries = (e) => {
    var arr = state.series.filter((item) => item.value == e)[0];
    if (arr.num) {
      resetField('num', { defaultValue: arr.num })
    }
  }





  const handleHide = () => {
    modal.hide();
  };


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }


  return (
    <BootstrapModal size="lg" {...bootstrapDialog(modal)} onHide={() => handleHide()}>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>{type} Voucher

          {id == 'new' ? null :
            <Popconfirm
              title="Delete?"
              description="Are you sure to delete this?"
              onConfirm={() => handleDelete(id)}
              okText="Yes"
              cancelText="No"
            >
              <button className="btn btn-outline-danger btn-sm ms-2" >Delete</button>
            </Popconfirm>
          }

        </BootstrapModal.Title>
      </BootstrapModal.Header>
      <OverlayLoader visible={loader} />
      {state.status ?
        <>
          <BootstrapModal.Body>

            <div className='row'>
              <div className='col-4'>
                <Controller

                  name="date"
                  control={control}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { invalid, isTouched, isDirty, error },
                    formState,
                  }) => (
                    <UiDatePicker

                      required={true}
                      label="Date"
                      onChange={(date) => { onChange(date); setStorage("last_date", date) }}
                      default_val={value}
                      message={errors.date?.message}
                      dateFormat="dd-MM-yyyy"
                      ref={(e) => {
                        ref(e)
                        inputRef.current = e
                      }}
                      name={name}
                    />
                  )}
                />
              </div>
              <div className='col-4'>
                <UiSelect
                  name='series'
                  label="Series"
                  required={true}
                  message={errors.series?.message}
                  options={state.series}
                  {...register(`series`, { onChange: (e) => { numSeries(e.target.value) } })}
                />
              </div>
              <div className='col-4'>
                <UiInput
                  name={`num`}
                  required={true}
                  label="Number"
                  {...register(`num`)}
                  message={errors.num?.message}
                />
              </div>
            </div>
            <div className='table-responsive'>
              <div className="d-flex pitable bg-white" style={{ minWidth: '650px' }} >
                <div className={`col1 border border-end-0 border-start-0`} style={{ width: '50px' }}>
                </div>

                <div className="col border border-end-0 p-1" style={{ width: '80px' }}>
                  Type
                </div>
                <div className="col border border-end-0 p-1" style={{ minWidth: '250px' }}>
                  Account
                </div>
                <div className="col1 border border-end-0 p-1" style={{ width: '140px' }}>Debit
                </div>
                <div className="col1 border border-end-0 p-1" style={{ width: '140px' }}>Credit
                </div>


                <div className="col1 border border-end-0 text-center p-1" style={{ width: '45px' }}>
                </div>
              </div>

              <SortableContainer onSortEnd={onSortEnd} useDragHandle>
                {fields.map((val, i) => (
                  <SortableItem key={i} index={i}>
                    <div className={`col1 border border-end-0 border-start-0`} style={{ width: '50px' }}>
                      <DragHandle />
                    </div>
                    <div className="col border border-end-0 p-1" style={{ width: '80px' }}>
                      <UiSelect
                        name={`entry.${i}.type`}
                        message={errors.entry?.[i]?.type?.message}
                        options={['Dr', 'Cr']}
                        {...register(`entry.${i}.type`, { onChange: (e) => calcTotal() })}
                      />
                    </div>
                    <div className="col border border-end-0 p-1" style={{ minWidth: '250px' }}>
                      <Controller
                        key={`item-${val.id}`}
                        name={`entry.${i}.account`}
                        control={control}
                        render={({ field }) => (

                          <UiClientSelect
                            {...field}
                            required={true}
                            category={entryWatch[i].type === 'Cr' ? (type == 'Receipt' ? [2, 19, 20] : type == 'Payment' ? [13, 14] : []) : (type == 'Receipt' ? [13, 14, 22, 23] : type == 'Payment' ? [1, 22, 23, 26] : [])}
                            fetch_onload
                            parentClass="mb-1"
                            className=""
                            message={errors.entry?.[i]?.account?.message}
                            label=""
                            onChange={(value, option) => {
                              field.onChange(value);
                              if (i > 1) {
                                if (entryWatch[i].type === 'Cr') {
                                  setValue(`entry.${i}.credit`, parseFloat(state.debit - state.credit).toFixed(2));
                                } else if (entryWatch[i].type === 'Dr') {
                                  setValue(`entry.${i}.debit`, parseFloat(state.credit - state.debit).toFixed(2));
                                }
                              }
                              calcTotal()
                              fetchBalance(value.value, getValues('date'), i)

                            }}

                          />

                        )}
                      />
                      <div className='text-end'><small >{entryWatch[i]?.balance}</small></div>
                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '140px' }}>

                      <UiInput
                        name={`entry.${i}.debit`}
                        {...register(`entry.${i}.debit`, { onChange: (e) => calcTotal() })}
                        parentClass="mb-0"
                        message={errors.entry?.[i]?.debit?.message}
                        noerror={true}
                        title={errors.entry?.[i]?.debit?.message}
                        disabled={entryWatch[i].type === 'Cr'}
                      />
                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '140px' }}>

                      <UiInput
                        name={`entry.${i}.credit`}
                        {...register(`entry.${i}.credit`, { onChange: (e) => calcTotal() })}
                        parentClass="mb-0"
                        message={errors.entry?.[i]?.credit?.message}
                        noerror={true}
                        disabled={entryWatch[i].type === 'Dr'}
                        title={errors.entry?.[i]?.credit?.message}
                      />
                    </div>


                    <div className="col1 border border-end-0 text-center p-1" style={{ width: '45px' }}>
                      <UiButton className="btn btn-outline-danger" onClick={() => remove(i)} icon="delete"> </UiButton>
                    </div>
                  </SortableItem>
                ))}
              </SortableContainer>

              <div className="d-flex pitable bg-white" style={{ minWidth: '650px' }} >
                <div className={`col1 border border-end-0 border-start-0`} style={{ width: '50px' }}>
                </div>
                <div className="col border border-end-0 p-1" style={{ width: '80px' }}></div>
                <div className="col border border-end-0 p-1 text-end" style={{ minWidth: '250px' }}>
                  Total:
                </div>
                <div className="col1 border border-end-0 p-1" style={{ width: '140px' }}>
                  {rupees(state.debit)}
                </div>
                <div className="col1 border border-end-0 p-1" style={{ width: '140px' }}>
                  {rupees(state.credit)}
                </div>


                <div className="col1 border border-end-0 text-center p-1" style={{ width: '45px' }}>
                </div>
              </div>
            </div>




            <div className="text-center mt-3">
              <UiButton className="btn btn-light" onClick={() => insertEntry()} title="Add Row" icon="add"> </UiButton>
            </div>


            <div className='row mb-3'>
              <div className="col-md-4">
                <UiInput

                  label="Narration"
                  name={`narration`}
                  {...register("narration", { onBlur: (e) => setValue('narration', titleCase(e.target.value)) })}
                  message={errors.narration?.message}
                  title={errors.narration?.message}
                />
                <Controller
                  name={`staff`}
                  control={control}
                  render={({ field }) => (

                    <UiClientSelect
                      {...field}
                      lcol="4"
                      icol="8"
                      parentClass="mb-1"
                      category={[26]}
                      className=""
                      fetch_onload
                      message={errors.staff?.message}
                      label="Staff"
                      onChange={(e) => { field.onChange(e); setStorage("staff", e.value) }}
                    />

                  )}
                />
                {type == 'Receipt' &&
                  <div className="form-check mt-4" >
                    <input className="form-check-input" type="checkbox" name="send_notification" id="notification" defaultChecked={(id == 'new' && getStorage('receipt_notification')) ? true : false} value="1" {...register("send_notification", { onChange: (e) => setStorage('receipt_notification', e.target.checked) })} />
                    <label className="form-check-label " htmlFor="notification">
                      Send Notification
                    </label>
                  </div>
                }
              </div>
            </div>

            {state.voucher.created_by && <p>Created By: {state.voucher.created_by} on {state.voucher.created_on}</p>}
            {state.voucher.updated_by && <p>Updated By: {state.voucher.updated_by} on {state.voucher.updated_on}</p>}
          </BootstrapModal.Body>
          <BootstrapModal.Footer className='justify-content-start'>
            <form id="jvform" onSubmit={handleSubmit(onSubmitHandler)}>
              <input type="hidden" value={id} name="id" {...register("id")} />
              <input type="hidden" value={type} name="type" {...register("type")} />
              <Button variant="primary" type="submit" disabled={fields.length == 0}>
                Save
              </Button>
            </form>
          </BootstrapModal.Footer>
        </> : <BgLoader />}
    </BootstrapModal>
  );
});

export default JournalVoucher;
